import { IMPERIAL_TO_METRIC_MAPPING, SYMBOL_TO_UNIT_MAPPING } from 'src/modules/common/constants';
import { SensorProduct } from 'src/sensors/list/SensorsPageMapping';
import { parseStringToUnit } from 'src/utils/parseStringToUnit';
import { Unit } from 'uom';

export const convertProbeLength = (
    probeLength: SensorProduct['ProbeLength'],
    isImperial: boolean,
): SensorProduct['ProbeLength'] => {
    if (!probeLength) {
        return probeLength;
    }

    const valueComposed = typeof probeLength === 'string'
        ? probeLength
        : probeLength?.localized.join(', ');

    const [parsedUnit] = parseStringToUnit(valueComposed);

    if (!parsedUnit) {
        return probeLength;
    }

    const measureSystem = isImperial ? 'imperial' : 'metric';
    const targetUnit = IMPERIAL_TO_METRIC_MAPPING[parsedUnit.unit.name][measureSystem];

    if (!targetUnit || parsedUnit.unit.name === targetUnit.name) {
        return probeLength;
    }

    const targetUnitSymbol = Object.keys(SYMBOL_TO_UNIT_MAPPING)
        .find((symbol) => SYMBOL_TO_UNIT_MAPPING[symbol].name === targetUnit.name);

    if (!targetUnit || !targetUnitSymbol) {
        return probeLength;
    }

    const convertedValue = Unit.convert(
        parsedUnit.value,
        parsedUnit.unit,
        targetUnit,
    );
    const roundedValue = Math.round(convertedValue);

    return {
        ...probeLength,
        localized: [`${roundedValue} ${targetUnitSymbol}`],
    };
};
